import TagsApi from '../api/TagsApi';
import TagsConstants from '../constants/TagsConstants';

function addTag(metadataId, type, value) {
  return {
    metadataId,
    types: [
      TagsConstants.ADD_TAG_REQUEST,
      TagsConstants.ADD_TAG_SUCCESS,
      TagsConstants.ADD_TAG_FAILURE
    ],
    middlewareData: {
      authRequired: true
    },
    apiRequest: (state, client) => TagsApi.addTag({
      metadataId,
      type,
      value,
      userId: state.getIn(['auth', 'currentUserId'])
    }, client)
  };
}

function removeTag(metadataId, tagId, type) {
  return {
    metadataId,
    tagId,
    types: [
      TagsConstants.REMOVE_TAG_REQUEST,
      TagsConstants.REMOVE_TAG_SUCCESS,
      TagsConstants.REMOVE_TAG_FAILURE
    ],
    middlewareData: {
      authRequired: true
    },
    apiRequest: (state, client) => TagsApi.removeTag({
      tagId,
      userId: state.getIn(['auth', 'currentUserId']),
      type
    }, client),
    apiSuccess: () => ({
      deletedEntities: [`ugc.tags.${tagId}`]
    })
  };
}

export default {
  addTag,
  removeTag
};



// WEBPACK FOOTER //
// ./app/actions/TagsActions.js